import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ProfileApiService } from 'app/services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-user-recovery-dialog',
  templateUrl: './user-recovery-dialog.component.html',
  styleUrls: ['./user-recovery-dialog.component.scss'],
})
export class RecoverUserDialogComponent implements OnInit {
  inputValue: FormControl;
  title = '';
  private onDestroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RecoverUserDialogComponent>,
    private _translateService: TranslateService,
    public profileService: ProfileApiService
  ) {}

  ngOnInit(): void {
    this.inputValue = new FormControl('', [Validators.email]);
    this.inputValueSelect();
  }
  inputValueSelect() {
    this._translateService
      .get('Recover_User')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.title = value;
      });
  }
  recoverUser() {
    this.profileService.recoverUser(this.inputValue.value).subscribe((res) => {
      if (res) {
        this.dialogRef.close(true);
      }
    });
  }
  checkEmail() {
    return (
        !this.inputValue.value ||
        this.inputValue.invalid ||
        this.inputValue.value.includes('@allegion.com')
    );
  }

  public close() {
    this.dialogRef.close();
  }
}
